export default __webpack_public_path__ + "static/media/genc-kart-nedir.2adcd96a.JPG";